// extracted by mini-css-extract-plugin
module.exports = {"attrValue":"AttributesCell_attrValue__JNfBI"};